import React from 'react'
import {Modal} from 'antd'
import ExistingBudgetForm from '../../../components/Common/Budgets/ExistingBudgetForm'

function ExistingBudgetModal(props) {
  const {
    visibleExisting,
    onCancelExisting,
    formExistingRef,
    submitExisting,
    submittingExisting,
  } = props
  return (
    <Modal
      destoryOnClose={true}
      width={'66%'}
      title={'Existing Budget'}
      visible={visibleExisting}
      onCancel={onCancelExisting}
      confirmLoading={submittingExisting}
      onOk={submitExisting}
      okText={'Select'}>
      <ExistingBudgetForm ref={formExistingRef} {...props} />
    </Modal>
  )
}

ExistingBudgetModal.propTypes = {}
ExistingBudgetModal.defaultProps = {}

export default ExistingBudgetModal
